module.exports = __webpack_public_path__ + "img/coopdk.41a8500b.png";